import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";
const savedLanguage = localStorage.getItem("staywork_language") || "en";
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
i18n.on("languageChanged", (language) => {
  localStorage.setItem("staywork_language", language);
  document.documentElement.lang = language;
});
document.documentElement.lang = savedLanguage;
export default i18n;
